import * as api from '../api/api';
import * as txnApi from '../api/transactions';
import * as userApi from '../api/user';

export const fetchSupportedCountries = async () => {
    try {
        const response = await userApi.getSupportedCountryStates();
        // console.log(response.data)
        return response.data;
    } catch (error) {
        // console.error('Error fetching countries:', error);
        return [];
    }
};

export const fetchSupportedCountryBanks = async (currencyCode, transferMethod) => {
    try {
        const response = await txnApi.getBanksByCurrency(currencyCode, transferMethod);
        return response.data;
    } catch (error) {
        // console.error('Error fetching country banks:', error);
        throw(error);
    }
};

export const fetchSupportedCountryStates = async () => {
    try {
        const response = await userApi.getSupportedCountryStates();
        // console.log(response.data)
        return response.data;
    } catch (error) {
        // console.error('Error fetching country states:', error);
        return [];
    }
};

export const fetchSupportedPaymentGateways = async () => {
    try {
        const response = await txnApi.getPaymentGateways();
        // console.log(response.data)
        return response.data;
    } catch (error) {
        // console.error('Error fetching payment gateways:', error);
        return [];
    }
};

export const contactFeedback = async (credentials) => {
    try {
        const response = await api.sendFeedback(credentials);
        return response.data;
    } catch (error) {
        // console.error('Error sending feedback:', error);
        return null;
    }
};

export const getAvailableTransferMethods = async (countryCode) => {
    try {
        const response = await userApi.allowedTransferMethods(countryCode);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        // console.error('Error fetching transfer methods:', error);
        return [];
    }
}